// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/email-confirmation-checkbox/bb_email_confirmation_checkbox.scss
// module id = 1222
// module chunks = 0